<template>
<div>
    <span v-if="!isEditing" :class="enableText == '是'?'red':''">
        {{enableText}}
      <!-- <el-button
          type="text"
          size="medium"
          @click="onEditEnable()">
                  编辑
       </el-button> -->
    </span>
    <span v-show="isEditing">
                <el-select
                  placeholder="请选择"
                  v-model="editingEnable"
                  size="medium"
                  class="course-score-selector"
                  style="width:95px;"
                >
                  <el-option :value="1" :label="'否'">
                    否
                  </el-option>
                  <el-option :value="0" :label="'是'">
                    是
                  </el-option>
                  
                </el-select>
                <el-button
                  type="text"
                  size="medium"
                  @click="onSaveEditEnable()"
                >
                  保存
                </el-button>
                <el-button
                  type="text"
                  size="medium"
                  @click="onCancelEditEnable()"
                >
                  取消
                </el-button>
              </span>
  </div>
</template>

<style lang="scss" scoped>
.red {
    color: red
}
</style>

<script>
import {
    saveAccountEnableChange
} from "../../../service/finance.service.js"
export default {
    props: {
        data: {},
        columnData: {},
        status: {}
    },
    data() {
        return {
          enable: 0,
          editingEnable: "",
          isEditing: false
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
        this.enable = this.data.Enable;
        this.enableText = this.enable ? "否" : "是";
        },
      onSaveEditEnable() {
        let self = this;
          saveAccountEnableChange(this.data.Id, this.editingEnable)
                .then(result => {
                    if (!!result && result.success) {
                        this.$message({
                            type: 'success',
                            message: '帐目更新成功!'
                        });
                        this.enable = this.editingEnable;
                        self.enableText = this.enable ? "否" : "是";
                        self.Reset();
                    } else {
                        self.Reset();
                        this.$message({
                            type: 'error',
                            message: '帐目更新失败! ' + result.message
                        });
                    }
                })
      },
       onEditEnable() {
         this.isEditing = true;
         this.editingEnable = this.enableText;
      },
      onCancelEditEnable() {
        this.isEditing = false;
      },
        Reset() {
            this.isEditing = false;
        }
    },
    watch: {
        data: function () {
            this.init();
        },
        status: function () {}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/accountListEnableCell.vue